<template>
  <v-card class="pa-2 mb-3">
    <v-card-actions>
      <document-pagination
        id="pagination"
        class="mx-auto"
        :current-page="currentPage"
        :total-pages="totalPages"
        @jumpToPage="jumpToPage($event)"
        @nextPage="nextPage"
        @prevPage="prevPage"
      ></document-pagination>
    </v-card-actions>

    <div ref="pdfContainer" class="pdf-container center-block">
      <v-overlay
        :absolute="true"
        :value="isProcessing"
      >
        <v-progress-circular
          indeterminate
          size="64"
          color="primary"
        ></v-progress-circular>
      </v-overlay>
      <canvas ref="pdfCanvas" class="pdf-canvas"></canvas>
    </div>
    <v-row>
      <pdf-password-modal
        ref="pdfPasswordModal"
        :visible.sync="pdfPasswordModalVisible"
        @passwordSpecified="loadPDFWithPassword"
        @passwordCancelled="handlePasswordCancelled"
      >
      </pdf-password-modal>
    </v-row>
    <v-row align="center" justify="center">
      <v-dialog v-model="incorrectShowed" max-width="378">
        <v-card id="incorrectShowed" class="pa-10 ">
          <v-card-text style="text-align: center">
            <v-container>
              <v-row justify="center">
                <v-icon x-large class="display-3 mb-2" color="error">mdi-block-helper</v-icon>
              </v-row>
              <v-row justify="center">
                <div class="text-h6 error--text">
                  {{ $t('toastMessage.incorrectPDFPassword') }}
                </div>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-btn
              id="OK_btn"
              color="primary"
              @click="getPasswordAgain"
            >
              {{ $t('main.ok') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-card>
</template>

<script>
import { fabric } from 'fabric'
import FontFaceObserver from 'fontfaceobserver'
// import * as pdfjs from 'pdfjs-dist/webpack.mjs'
// import * as pdfjs from 'pdfjs-dist'
import * as pdfjs from 'pdfjs-dist/legacy/build/pdf.mjs'
// import * as pdfjs from 'pdfjs-dist'
// import * as pdfjs from 'pdfjs-dist/webpack.mjs'
// import PDFJSWorker from 'pdfjs-dist/build/pdf.worker.entry'
// import PDFJSWorker from 'pdfjs-dist/build/pdf.worker.min.js'
// import * as pdfjs from 'pdfjs-dist/webpack'
/* import * as pdfjs from 'pdfjs-dist/legacy/build/pdf'
import * as pdfjs from 'pdfjs-dist/webpack.mjs'

import PDFJSWorker from 'pdfjs-dist/legacy/build/pdf.worker.entry'
pdfjs.GlobalWorkerOptions.workerSrc = PDFJSWorker */

// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
import { showToastError } from '@/event-bus'
import DocumentPagination from './DocumentPagination'
import PDFPasswordModal from './PDFPasswordModal'
// pdfjs.GlobalWorkerOptions.workerSrc = PDFJSWorker
// pdfjs.GlobalWorkerOptions.workerSrc = '//unpkg.com/pdfjs-dist@3.1.81/build/pdf.worker.min.js'
// pdfjs.GlobalWorkerOptions.workerSrc = '/js/pdf.worker.min.js'
pdfjs.GlobalWorkerOptions.workerSrc = '/js/pdf.worker.min.js'
/* pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  '/js/pdf.worker.min.mjs',
  import.meta.url
).toString() */
// pdfjs.GlobalWorkerOptions.workerSrc = '//unpkg.com/pdfjs-dist@4.10.38/build/pdf.worker.min.js'

export default {
  name: 'VisibleSignature',

  components: {
    DocumentPagination, 'pdf-password-modal': PDFPasswordModal
  },

  props: {
    docData: {
      type: String,
      default: undefined
    },
    pdfEncrypted: {
      type: Boolean,
      default: false
    },
    signProf: {
      type: Object,
      default: undefined
    },
    allowSignProfileEditing: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      localPdfEncrypted: this.pdfEncrypted,
      dontCallpdfLoaded: false,
      // isProcessing: true,
      isProcessing: false,
      pdfDoc: null,
      incorrectShowed: false,
      currentPage: 1,
      // currentPage: null,
      totalPages: 0,
      signatureProfile: {},
      imgDataURL: null,
      documentWidth: 0,
      documentHeight: 0,
      defaultTextWidth: 300,
      defaultTextHeight: 20,
      defaultImageHeight: 100,
      imageWidth: 0,
      imageHeight: 0,
      scaledWidth: 0,
      scaledHeight: 0,
      initialImageWidth: 0,
      initialImageHeight: 0,
      fabricControlsInited: false,
      width: 0,
      height: 0,
      top: 0,
      left: 0,
      signatureProfileKey: 0,
      overlayKey: 0,
      signerTextVisible: false,
      signerImageVisible: false,
      aspectRatio: true,
      canRenderDraggable: false,
      fcanvas: null,
      signatureImageGroup: null,
      signatureFabricText: null,
      signatureImg: null,
      anottationControls: { mtr: false, mr: false, ml: false, mt: false, mb: false },
      signatureDragHandleColor: this.$vuetify.theme.currentTheme.primary,
      signatureTextFont: 'PT Serif',
      signatureImageTextSize: 24,
      signatureImageDefaultTextSize: 24,
      signatureTextColor: '#000000',
      signatureTextAlign: 'left',
      imageDataFormat: { format: 'image/png' },
      isObjectMoving: false,
      isObjectScaling: false,
      pdfPasswordModalVisible: false,
      pdf_password: null
    }
  },
  computed: {
    pdfLoaded() {
      return this.pdfDoc && this.totalPages > 0
    }
  },
  watch: {
    pdfEncrypted(newValue) {
      this.localPdfEncrypted = newValue
    },
    docData(val) {
      // this.getPdf(val)
      this.updateDocData(val)
    },

    signProf(val) {
      // this.signatureProfile = val
      this.signatureProfile = JSON.parse(JSON.stringify(val))

      this.redrawEverything()
    },

    currentPage(val) {
      const num = parseInt(val)
      if (isNaN(num)) {
        this.currentPage = 1
        this.$emit('pageChanged')
        return
      }

      if (this.pdfLoaded && (num < 0 || num > this.totalPages)) {
        this.currentPage = 1
        this.$emit('pageChanged')
        return
      }

      if (this.pdfLoaded) {
        // window.scrollTo(window.pageXOffset, 0)
        this.$nextTick(() => {
          this.renderPage()
          this.$emit('pageChanged')
          // this.emitSignatureProfile()
        })
      }
    }
  },
  mounted() {
    window.fabric.Object.prototype.objectCaching = false

    const font = new FontFaceObserver(this.signatureTextFont)

    font.load().then(function() {
    })
  },

  methods: {
    updateEncryptionStatus(value) {
      this.$emit('update:pdfEncrypted', value)
      // If you need local state:
      this.localPdfEncrypted = value
    },
    updateSignatureProfile(val) {
      // this.signatureProfile = val
      this.signatureProfile = JSON.parse(JSON.stringify(val))

      this.redrawEverything()
    },
    updateDocData(docData) {
      // Update the internal docData property
      this.getPdf(docData)
    },

    handlePasswordCancelled() {
      this.pdfPasswordModalVisible = false
      this.$emit('passwordCancelled')
      showToastError(this.$t('toastMessage.cantDisplayPDFWithoutPasswordSpecified'))
    },

    getPasswordAgain() {
      this.incorrectShowed = false
      this.pdfPasswordModalVisible = true
    },

    getPassword() {
      return this.pdf_password
    },

    getEncrypted() {
      return this.localPdfEncrypted
    },

    setPassword(value) {
      this.pdf_password = value

      const pdfPasswordModalComponent = this.$refs.pdfPasswordModal
      pdfPasswordModalComponent.resetPassword()
    },

    loadPDFWithPassword(password) {
      this.pdfPasswordModalVisible = false
      this.pdf_password = password
      this.$emit('passwordSpecified', this.pdf_password)
      this.loadPdf(this.docData)
    },

    async loadPdf(docData) {
      try {
        const loadingTask = pdfjs.getDocument({ data: this.base64ToUint8Array(docData), password: this.pdf_password })
        loadingTask.promise
          .then(pdf => {
            this.pdfDoc = pdf
            this.totalPages = pdf.numPages
            this.renderPage()
          })
          .catch((e) => {
            if (e.name === 'PasswordException') {
              this.pdf_password = null
              // showToastError(this.$t('toastMessage.incorrectPDFPassword'))
              this.incorrectShowed = true
            }
          })
      } catch (error) {
        if (!(error.name === 'PasswordException')) {
          this.pdf_password = null
          showToastError(this.$t('toastMessage.incorrectPDFPassword'))
        } else {
          console.error(error)
          showToastError(this.$t('toastMessage.invalidPdf', { 0: error }))
        }
      }
    },

    async getPdf(docData) {
      try {
        if (this.localPdfEncrypted && !this.pdf_password) {
          this.pdfPasswordModalVisible = true
        } else {
          this.loadPdf(docData)
        }
      } catch (error) {
        console.error(error)
        showToastError(this.$t('toastMessage.invalidPdf', { 0: error }))
      }
    },

    redrawEverything() {
      if (this.fcanvas) {
        this.fcanvas.remove(...this.fcanvas.getObjects())
      }

      if (this.signatureProfile.textParams) {
        if (this.signatureProfile.textParams.textColor) {
          this.signatureTextColor = this.getHexColorFromBackendColor(this.signatureProfile.textParams.textColor)
        } else {
          this.signatureTextColor = '#000000'
        }
        if (this.signatureProfile.textParams.backgroundColor) {
          this.signatureTextBackgroundColor = this.getHexColorFromBackendColor(this.signatureProfile.textParams.backgroundColor)
          this.textBackgroundColorIsTransparent = false
        } else {
          this.textBackgroundColorIsTransparent = true
          this.signatureTextBackgroundColor = 'transparent'
        }

        if (this.signatureProfile.textParams.size) {
          this.signatureImageTextSize = this.signatureProfile.textParams.size
          this.autoSizeText = false
        } else {
          this.autoSizeText = true
          this.signatureImageTextSize = this.signatureImageDefaultTextSize
        }
      }
      // debugger

      if (this.signatureProfile.sourceImageDataUrl) {
        this.signerImageVisible = true
        this.getImageDimensions(this.signatureProfile.sourceImageDataUrl)
        this.aspectRatio = true
      } else {
        this.aspectRatio = false
        // this.aspectRatio = true
        this.signerImageVisible = false
        this.imageWidth = this.defaultTextWidth
        this.imageHeight = this.defaultTextHeight
      }

      if ((this.signatureProfile) && (this.signatureProfile.textParams) && (this.signatureProfile.textParams.text) && (this.signatureProfile.textParams.text.length > 0)) {
        this.signerTextVisible = true
      } else {
        this.signerTextVisible = false
      }

      if (this.signerTextVisible && !this.signerImageVisible) {
        const isPositionSavedInProfile = !!this.signatureProfile.savedSignatureFieldParameters

        this.addSignatureText(isPositionSavedInProfile ? this.signatureProfile.savedSignatureFieldParameters.originX : 20,
          // isPositionSavedInProfile ? this.signatureProfile.savedSignatureFieldParameters.originY : 20, isPositionSavedInProfile ? this.signatureProfile.savedSignatureFieldParameters.width : this.defaultTextWidth)
          isPositionSavedInProfile ? this.signatureProfile.savedSignatureFieldParameters.originY : 20, isPositionSavedInProfile ? this.signatureProfile.savedSignatureFieldParameters.width : null)
        this.signatureFabricText.setControlsVisibility(this.anottationControls)

        if (this.autoSizeText) {
          const scale = this.getAutoSizeTextScale()
          this.signatureFabricText.scale(scale)
        } else {
          this.signatureFabricText.set('fontSize', this.signatureImageTextSize)
        }
        // this.signatureFabricText.scaleToWidth(320)
        this.applySignatureEditability(this.signatureFabricText)
        this.fcanvas.add(this.signatureFabricText)
        this.fcanvas.renderAll()
        this.addObjectLimits()
      }

      if (this.signatureProfile.savedSignatureFieldParameters && this.currentPage !== this.signatureProfile.savedSignatureFieldParameters.page) {
        setTimeout(() => {
          if (this.pdfLoaded && this.signatureProfile.savedSignatureFieldParameters.page > this.totalPages) {
            this.dontCallpdfLoaded = true
            this.currentPage = 1
          } else
          if (this.signatureProfile.savedSignatureFieldParameters.page !== undefined) {
            this.dontCallpdfLoaded = true
            this.currentPage = this.signatureProfile.savedSignatureFieldParameters.page
          }
        }, 1000)
      }
    },
    applySignatureEditability(obj) {
      if (!obj) return

      obj.set({
        lockMovementX: !this.allowSignProfileEditing,
        lockMovementY: !this.allowSignProfileEditing,
        lockScalingX: !this.allowSignProfileEditing,
        lockScalingY: !this.allowSignProfileEditing,
        lockRotation: true,
        selectable: true
      })

      obj.setControlsVisibility({
        tl: this.allowSignProfileEditing,
        tr: this.allowSignProfileEditing,
        br: this.allowSignProfileEditing,
        bl: this.allowSignProfileEditing,
        mt: this.allowSignProfileEditing,
        mb: this.allowSignProfileEditing,
        ml: this.allowSignProfileEditing,
        mr: this.allowSignProfileEditing,
        mtr: false
      })

      this.fcanvas?.renderAll()
    },
    async renderPage() {
      if (!this.currentPage || (this.currentPage > this.totalPages)) {
        this.currentPage = 1
        return
      }
      if (this.isProcessing) {
        return
      }
      this.canRenderDraggable = false
      this.isProcessing = true
      const page = await this.pdfDoc.getPage(this.currentPage)
      const viewport = page.getViewport({ scale: 1.0 })

      // Not working correctly, so fixed now to 1: Support HiDPI-screens.
      // const outputScale = window.devicePixelRatio || 1
      const outputScale = 1

      // Apply page dimensions to the <canvas> element.
      const pdfContainer = this.$refs.pdfContainer
      const pdfCanvas = this.$refs.pdfCanvas
      const ctx = pdfCanvas.getContext('2d')

      if (pdfContainer !== undefined) {
        pdfContainer.style.height = viewport.height + 'px'
        pdfContainer.style.width = viewport.width + 'px'
      }

      if (pdfCanvas !== undefined) {
        pdfCanvas.width = Math.floor(viewport.width * outputScale)
        this.documentWidth = pdfCanvas.width
        pdfCanvas.height = Math.floor(viewport.height * outputScale)
        this.documentHeight = pdfCanvas.height
      } else {
      }

      // Render the page into the <canvas> element.
      var renderContext = {
        canvasContext: ctx,
        viewport: viewport
      }
      this.canRenderDraggable = true
      var renderTask = page.render(renderContext)
      await renderTask.promise
      this.loadf(pdfCanvas)

      this.isProcessing = false
    },

    loadf(canvas) {
      const bg = canvas.toDataURL('image/png')
      if (!this.fcanvas) {
        const canvasElement = this.$refs.pdfCanvas
        this.fcanvas = new fabric.Canvas(canvasElement, {
        // this.fcanvas = new fabric.Canvas('the-canvas', {
          selection: false,
          enableRetinaScaling: false
        })
      }

      this.fcanvas.setBackgroundImage(bg, this.fcanvas.renderAll.bind(this.fcanvas))
      this.fcanvas.setWidth(canvas.width)
      this.fcanvas.setHeight(canvas.height)

      this.$emit('pdfLoaded', true)
      this.dontCallpdfLoaded = false
    },

    // Displays previous page
    prevPage() {
      if (this.currentPage <= 1) {
        return
      }
      this.currentPage--
      this.emitSignatureProfile()
    },

    // Displays next page
    nextPage() {
      if (this.currentPage >= this.pdfDoc.numPages) {
        return
      }
      this.currentPage++
      this.emitSignatureProfile()
    },
    jumpToPage(page) {
      this.currentPage = page
      this.emitSignatureProfile()
    },
    refreshAutoText() {
      if (this.signerTextVisible) {
        this.$refs.fittyText.refresh()
      }
    },

    setFieldParams(params) {
      this.signatureProfile.savedSignatureFieldParameters = Object.assign({}, this.signatureProfile.savedSignatureFieldParameters, params)
      this.currentPage = params.page
    },

    getSignatureFieldParameters() {
      const usedObj = (this.signerTextVisible && !this.signerImageVisible) ? this.signatureFabricText : (this.signerTextVisible ? this.signatureImageGroup : this.signatureImg)

      if (!usedObj) {
        return undefined
      }

      const signatureImageFieldParameters = {
        page: this.currentPage,
        originX: usedObj.left,
        originY: usedObj.top,
        width: usedObj.getBoundingRect().width,
        height: usedObj.getBoundingRect().height
      }
      return signatureImageFieldParameters
    },

    updateOwnSignatureProfile() {
      const signatureImageFieldParameters = {
        page: this.currentPage,
        originX: this.left,
        originY: this.top,
        width: this.scaledWidth,
        height: this.scaledHeight
      }
      this.signatureProfile.savedSignatureFieldParameters = Object.assign({}, this.signatureProfile.savedSignatureFieldParameters, signatureImageFieldParameters)
    },

    isPDFCanvasFullyLoaded() {
      return (this.fcanvas !== undefined) && (this.fcanvas !== null)
    },

    emitSignatureProfile() {
      this.updateOwnSignatureProfile()
      this.$emit('updatedSignProf', this.signatureProfile)
      if (this.signerTextVisible) {
        /* const style = window.getComputedStyle(fittybox, null).getPropertyValue('font-size')
          // const fontSize = Math.round(parseFloat(style))
          const fontSize = Math.trunc(parseFloat(style))
          this.$emit('updatedTextSize', fontSize) */
      }
    },

    async emitSignatureProfileImage() {
      let dataurl = null
      if (this.signerTextVisible && !this.signerImageVisible) {
        dataurl = this.signatureFabricText.toDataURL(this.imageDataFormat)
      } else {
        if (!this.signerTextVisible && this.signerImageVisible) {
          dataurl = this.signatureImg.toDataURL(this.imageDataFormat)
        } else {
          dataurl = this.signatureImageGroup.toDataURL(this.imageDataFormat)
        }
      }
      this.$emit('updatedSignatureProfileImage', dataurl)
    },

    base64ToUint8Array(base64) {
      var raw = window.atob(base64)
      var uint8Array = new Uint8Array(raw.length)
      for (var i = 0; i < raw.length; i++) {
        uint8Array[i] = raw.charCodeAt(i)
      }
      return uint8Array
    },

    getImageDimensions(imageDataUrl) {
      const img = new Image()
      img.src = imageDataUrl
      img.decode().then(() => {
        const width = img.naturalWidth
        const height = img.naturalHeight

        this.calculateImageAspectRatioFit(img, width, height)
      })
    },

    getHexColorFromBackendColor(colorObject) {
      const hex = '#' + ((1 << 24) + (colorObject.red << 16) + (colorObject.green << 8) + colorObject.blue).toString(16).slice(1)
      return hex
    },

    addSignatureText(textLeft, textTop, w, h) {
      // this.signatureFabricText = new fabric.IText(this.signatureProfile.textParams.text, { left: 0, top: textTop, width: w, transparentCorners: false, fontFamily: 'PT Serif', fontSize: 14, textAlign: 'left', lockUniScaling: true })
      this.signatureFabricText = new fabric.IText(this.signatureProfile.textParams.text, {
        left: textLeft,
        top: textTop,
        transparentCorners: false,
        fontFamily: this.signatureTextFont,
        fontSize: this.signatureImageTextSize,
        textAlign: this.signatureTextAlign,
        fill: this.signatureTextColor,
        backgroundColor: this.textBackgroundColorIsTransparent ? 'transparent' : this.signatureTextBackgroundColor,
        editable: false, // Disable inline editing
        // lockUniScaling: true,
        borderColor: this.signatureDragHandleColor,
        cornerColor: this.signatureDragHandleColor
      })
      if ((w !== null) && (w !== undefined)) {
        this.signatureFabricText.scaleToWidth(w)
      }
      this.signatureFabricText.setControlsVisibility({ mtr: false, mr: false, ml: false })
    },

    addObjectLimits() {
      this.fcanvas.on('mouse:up', function(event) {
        if (this.isObjectMoving) {
          this.isObjectMoving = false
          this.$emit('draggingFinished')
        }
        if (this.isObjectScaling) {
          this.isObjectScaling = false
          this.$emit('sizingFinished')
        }
      }.bind(this))
      this.fcanvas.on('object:moving', function(e) {
        var obj = e.target

        // if object is too big ignore
        if (obj.currentHeight > obj.canvas.height || obj.currentWidth > obj.canvas.width) {
          return
        }

        this.isObjectMoving = true

        obj.setCoords()
        // top-left  corner
        if (obj.getBoundingRect().top < 0 || obj.getBoundingRect().left < 0) {
          obj.top = Math.max(obj.top, obj.top - obj.getBoundingRect().top)
          obj.left = Math.max(obj.left, obj.left - obj.getBoundingRect().left)
        }
        // bot-right corner
        if (obj.getBoundingRect().top + obj.getBoundingRect().height > obj.canvas.height || obj.getBoundingRect().left + obj.getBoundingRect().width > obj.canvas.width) {
          obj.top = Math.min(obj.top, obj.canvas.height - obj.getBoundingRect().height + obj.top - obj.getBoundingRect().top)
          obj.left = Math.min(obj.left, obj.canvas.width - obj.getBoundingRect().width + obj.left - obj.getBoundingRect().left)
        }

        this.left = obj.left
        this.top = obj.top
        this.scaledWidth = obj.getBoundingRect().width
        this.scaledHeight = obj.getBoundingRect().height

        this.updateOwnSignatureProfile()

        this.emitSignatureProfile()
      }.bind(this))
      this.fcanvas.on('object:scaling', function(e) {
        var obj = e.target
        // if object is too big ignore
        if (obj.currentHeight > obj.canvas.height || obj.currentWidth > obj.canvas.width) {
          return
        }

        this.isObjectScaling = true

        obj.setCoords()
        // top-left  corner
        if (obj.getBoundingRect().top < 0 || obj.getBoundingRect().left < 0) {
          obj.top = Math.max(obj.top, obj.top - obj.getBoundingRect().top)
          obj.left = Math.max(obj.left, obj.left - obj.getBoundingRect().left)
        }
        // bot-right corner
        if (obj.getBoundingRect().top + obj.getBoundingRect().height > obj.canvas.height || obj.getBoundingRect().left + obj.getBoundingRect().width > obj.canvas.width) {
          obj.top = Math.min(obj.top, obj.canvas.height - obj.getBoundingRect().height + obj.top - obj.getBoundingRect().top)
          obj.left = Math.min(obj.left, obj.canvas.width - obj.getBoundingRect().width + obj.left - obj.getBoundingRect().left)
        }

        this.left = obj.left
        this.top = obj.top
        this.scaledWidth = obj.getBoundingRect().width
        this.scaledHeight = obj.getBoundingRect().height

        this.emitSignatureProfile()
        // this.emitSignatureProfileImage()
      }.bind(this))
    },

    getAutoSizeTextScale() {
      if (this.fcanvas) {
        const canvasWidth = this.fcanvas.getWidth()
        const canvasHeight = this.fcanvas.getHeight()
        const textWidth = this.signatureFabricText.getScaledWidth()
        const textHeight = this.signatureFabricText.getScaledHeight()
        const scale = Math.min(canvasWidth / textWidth, canvasHeight / textHeight)
        return scale
      }
      return 0
    },

    isFabricControlsInited() {
      return this.fabricControlsInited
    },

    calculateImageAspectRatioFit(img, srcWidth, srcHeight) {
      if (!this.fcanvas) {
        return
      }
      const maxWidth = this.defaultTextWidth // Max width for the image
      const maxHeight = this.defaultImageHeight // Max height for the image

      const isPositionSavedInProfile = this.signatureProfile.savedSignatureFieldParameters && (this.signatureProfile.savedSignatureFieldParameters.width > 0)

      // const ratio = isPositionSavedInProfile ? Math.min(maxWidth / this.signatureProfile.savedSignatureFieldParameters.width, maxHeight / this.signatureProfile.savedSignatureFieldParameters.height) : Math.min(maxWidth / srcWidth, maxHeight / srcHeight)
      const ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight)

      if (isPositionSavedInProfile) {
        this.imageWidth = this.signatureProfile.savedSignatureFieldParameters.width
        this.imageHeight = this.signatureProfile.savedSignatureFieldParameters.height
        this.scaledHeight = this.imageHeight
      } else {
        this.imageWidth = srcWidth * ratio
        this.imageHeight = srcHeight * ratio
        this.scaledHeight = this.imageHeight
      }

      this.initialImageWidth = this.imageWidth
      this.initialImageHeight = this.imageHeight

      if (isPositionSavedInProfile) {
        if ((Math.floor(this.signatureProfile.savedSignatureFieldParameters.originX) + Math.floor(this.signatureProfile.savedSignatureFieldParameters.width)) > this.fcanvas.width) {
          this.signatureProfile.savedSignatureFieldParameters.originX = 0
          this.signatureProfile.savedSignatureFieldParameters.originY = 0
        }
        if ((Math.floor(this.signatureProfile.savedSignatureFieldParameters.originY) + Math.floor(this.signatureProfile.savedSignatureFieldParameters.height)) > this.fcanvas.height) {
          this.signatureProfile.savedSignatureFieldParameters.originX = 0
          this.signatureProfile.savedSignatureFieldParameters.originY = 0
        }
      }

      this.signatureImg = new fabric.Image(img, {
        left: this.signerTextVisible ? 0 : (isPositionSavedInProfile ? this.signatureProfile.savedSignatureFieldParameters.originX : 0),
        top: this.signerTextVisible ? 0 : (isPositionSavedInProfile ? this.signatureProfile.savedSignatureFieldParameters.originY : 0),
        transparentCorners: false,
        borderColor: this.signatureDragHandleColor,
        cornerColor: this.signatureDragHandleColor,
        flipX: false,
        flipY: false
        /* width: this.imageWidth,
        height: this.imageHeight */
        // opacity: 0.85
      })

      this.signatureImg.setControlsVisibility(this.anottationControls)

      if (isPositionSavedInProfile) {
        this.signatureImg.scaleToWidth(this.signatureProfile.savedSignatureFieldParameters.width)

        if (this.signerTextVisible) {
          this.signatureImg.set({ top: 0 })
        }
        // oImg.scaleToHeight(50);
      } else {
      // imgInstance.scaleToWidth(this.imageWidth, false)
        this.signatureImg.set({
          scaleX: ratio,
          scaleY: ratio
        })
      }

      if (this.signerTextVisible) {
        // this.addSignatureText(0, isPositionSavedInProfile ? this.signatureImg.getScaledHeight() : this.imageHeight, this.imageWidth)
        this.addSignatureText(0, isPositionSavedInProfile ? this.signatureImg.getScaledHeight() : this.imageHeight)

        if (this.autoSizeText) {
          /* const scale = this.getAutoSizeTextScale()
          this.signatureFabricText.scale(scale) */
          this.signatureFabricText.scaleToWidth(this.imageWidth)
        } else {
          this.signatureFabricText.set('fontSize', this.signatureImageTextSize)
        }
        // this.signatureFabricText.scaleToWidth(this.imageWidth)
        const textH = this.signatureFabricText.getScaledHeight()
        this.signatureImageGroup = new fabric.Group([this.signatureImg, this.signatureFabricText], {
          left: isPositionSavedInProfile ? this.signatureProfile.savedSignatureFieldParameters.originX : 0,
          top: isPositionSavedInProfile ? this.signatureProfile.savedSignatureFieldParameters.originY : 0,
          width: this.imageWidth,
          height: isPositionSavedInProfile ? this.signatureProfile.savedSignatureFieldParameters.height : this.imageHeight + textH,
          transparentCorners: false,
          borderColor: this.signatureDragHandleColor,
          cornerColor: this.signatureDragHandleColor
        })
        this.signatureImageGroup.setControlsVisibility(this.anottationControls)
        this.applySignatureEditability(this.signatureImageGroup)
        this.fcanvas.add(this.signatureImageGroup)
        this.fabricControlsInited = true
      } else {
        this.applySignatureEditability(this.signatureImg)
        this.fcanvas.add(this.signatureImg)
        this.fabricControlsInited = true
      }
      this.fcanvas.renderAll()

      this.addObjectLimits()
    },

    forceRefreshComponent() {
      this.signatureProfileKey += 1
    }
  }

}
</script>

<style scoped>
.pdf-canvas {
  border: 1px solid black;
  direction: ltr;
}

.pdf-container {
  margin-top: 20px;
  margin-bottom: 20px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
}

</style>
